import { addMonths, diffDay } from '@ha/date';

import {
  isDayExcluded,
  isDayBefore,
  isDayAfter,
  RangeModifier,
} from 'ha/ui/next/DatePicker';

import { DateSelectionRules } from '../types';

const isFromDateDisabled = (
  day: Date,
  exclusions: RangeModifier[],
  minimumPeriod: number,
  dateSelectionRules: DateSelectionRules = {},
) => {
  const { minDate, maxDate } = dateSelectionRules;

  if (minDate && isDayBefore(day, new Date(minDate))) {
    return true;
  }

  if (maxDate && isDayAfter(day, new Date(maxDate))) {
    return true;
  }

  // current day is excluded
  if (isDayExcluded(day, exclusions)) {
    return true;
  }

  const minimalPeriodDays =
    diffDay(addMonths(day.toISOString(), minimumPeriod), day) - 1;

  return exclusions.some(({ from }) => {
    const diff = diffDay(from, day);

    return diff >= 0 && diff <= minimalPeriodDays;
  });
};

export default isFromDateDisabled;
